module.exports={
	"Form": "EquipmentEditManifest",
	"Scope": "Equipment-Edit",
	"Descriptors":
	{
		"EquipmentDetails.Name":
		{
			"Name": "Name",
			"Hash": "Equipment-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Equipment-Edit-Identity",
				"Group": "Equipment-Edit-Identity"
			}
		},
		"EquipmentDetails.Code":
		{
			"Name": "Code",
			"Hash": "Equipment-Edit-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "Equipment-Edit-Identity",
				"Group": "Equipment-Edit-Identity"
			}
		},
		"EquipmentDetails.Description":
		{
			"Name": "Description",
			"Hash": "Equipment-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "Equipment-Edit-Details",
				"Group": "Equipment-Edit-Details"
			}
		},
		"EquipmentDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "Equipment-Edit-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "Equipment-Edit-Details",
				"Group": "Equipment-Edit-Details"
			}
		},
		"EquipmentDetails.SpecificationYear":
		{
			"Name": "Specification Year",
			"Hash": "Equipment-Edit-SpecificationYear",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Equipment-Edit-Details",
				"Group": "Equipment-Edit-Details"
			}
		},
		"EquipmentDetails.Status":
		{
			"Name": "Status",
			"Hash": "Equipment-Edit-Status",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Equipment-Edit-Details",
				"Group": "Equipment-Edit-Details"
			}
		},
		"EquipmentDetails.ExternalEquipmentID":
		{
			"Name": "External Equipment ID",
			"Hash": "Equipment-Edit-ExternalEquipmentID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Equipment-Edit-Details",
				"Group": "Equipment-Edit-Details"
			}
		},
		"EquipmentDetails.IDEquipment":
		{
			"Name": "IDEquipment",
			"Hash": "Equipment-Edit-IDEquipment",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Equipment-Edit-DataAudit",
				"Group": "Equipment-Edit-DataAudit"
			}
		},
		"EquipmentDetails.GUIDEquipment":
		{
			"Name": "GUIDEquipment",
			"Hash": "Equipment-Edit-GUIDEquipment",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Equipment-Edit-DataAudit",
				"Group": "Equipment-Edit-DataAudit"
			}
		},
		"EquipmentDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Equipment-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Equipment-Edit-DataAudit",
				"Group": "Equipment-Edit-DataAudit"
			}
		},
		"EquipmentDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Equipment-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Equipment-Edit-DataAudit",
				"Group": "Equipment-Edit-DataAudit"
			}
		},
		"EquipmentDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Equipment-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Equipment-Edit-DataAudit",
				"Group": "Equipment-Edit-DataAudit"
			}
		},
		"EquipmentDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Equipment-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Equipment-Edit-DataAudit",
				"Group": "Equipment-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Equipment-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Equipment-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Equipment-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Equipment-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Equipment-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Equipment-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
